export const selectShowModal = (state) => state.modal.show
